import { IS_LOCAL } from 'actions/utils';
import { setUserId, setUserProperties } from 'firebase/analytics';
import { OrgUsers, Organizations } from 'utils/gloo-types';
import { analytics } from './firebase';

// eslint-disable-next-line import/prefer-default-export
export function setUser(orgUserId: number | null, properties?: { organization?: Organizations; orgUser?: OrgUsers }) {
  try {
    if (IS_LOCAL) {
      console.warn(`Analytics local: Setting user id: ${orgUserId}`, properties);
      return;
    }
    if (orgUserId) {
      setUserId(analytics, `${orgUserId}`);
      if (properties) {
        setUserProperties(analytics, {
          orgName: properties?.organization?.name,
          orgId: properties?.organization?.id,
          name: properties?.orgUser?.name,
          email: properties?.orgUser?.email,
        });
      }
    } else {
      setUserId(analytics, null);
    }
  } catch (error) {
    console.error('error analytics setting user', error);
  }
}
